import React, { Component } from 'react';
import { Modal, Row, Col, Table } from 'react-bootstrap';
import _ from 'lodash';
import {
  getWorkTypeNameById,
  getSubWorkTypeNameById,
  getAddress,
} from '../../utils';

const backdropStyle = {
  position: 'fixed',
  zIndex: 1040,
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: '#000',
  opacity: 0.5,
};

class PublicationCoregPreviewModal extends Component {
  renderBackdrop(props) {
    return <div {...props} style={backdropStyle} />;
  }

  getWorkTitles() {
    const workTitles = this.props.fields.workTitles || [];

    let data = [];
    workTitles.forEach((workTitle) => {
      data = [...data, workTitle.title];
    });

    return data.join(' ');
  }

  renderAuthors() {
    const { fields } = this.props;

    return (
      fields.authors && (
        <div className="table-container">
          <Table>
            <thead>
              <tr>
                <th>
                  <span className="text-red">*</span>First Name
                </th>
                <th>Middle Name</th>
                <th>
                  <span className="text-red">*</span>Last Name
                </th>
                <th>Organization</th>
                <th>
                  <span className="text-red">*</span>Citizenship or
                  <br />
                  Domicile
                </th>
                <th>State</th>
                <th>Country</th>
              </tr>
            </thead>
            <tbody>
              {fields.authors.map((author, i) => (
                <tr key={i}>
                  <td>{author.firstName}</td>
                  <td>{author.middleName}</td>
                  <td>{author.lastName}</td>
                  <td className="text-center">{author.organization}</td>
                  <td>{author.citizenship || author.domicile}</td>
                  {/* <td className="text-center">{author.anonymous ? 'Y' : ''}</td> */}
                  <td>{author.state}</td>
                  <td>{author.country}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )
    );
  }

  renderClaimants() {
    const { fields } = this.props;

    return (
      fields.claimants && (
        <div className="table-container">
          <Table>
            <thead>
              <tr>
                <th>
                  <span className="text-red">*</span>First Name
                </th>
                <th>Middle Name</th>
                <th>
                  <span className="text-red">*</span>Last Name
                </th>
                <th>Organization</th>
                <th>
                  <span className="text-red">*</span>Address
                </th>
              </tr>
            </thead>
            <tbody>
              {fields.claimants.map(
                (claimant, i) =>
                  (!_.has(claimant, 'transfer') ||
                    _.has(claimant, 'newClaimant')) && (
                    <tr key={i}>
                      <td>{claimant.firstName}</td>
                      <td>{claimant.middleName}</td>
                      <td>{claimant.lastName}</td>
                      <td className="text-center">
                        {claimant.organization || ''}
                      </td>
                      <td>{getAddress(claimant)}</td>
                    </tr>
                  )
              )}
            </tbody>
          </Table>
        </div>
      )
    );
  }

  renderClaimantsTransfer() {
    const { fields } = this.props;

    return (
      fields.claimants && (
        <div className="table-container">
          <Table>
            <thead>
              <tr>
                <th>
                  <span className="text-red">*</span>First Name
                </th>
                <th>Middle Name</th>
                <th>
                  <span className="text-red">*</span>Last Name
                </th>
                <th>Organization</th>
                <th>Transfer Statement Type</th>
                <th>Transfer Statement Other</th>
              </tr>
            </thead>
            <tbody>
              {fields.claimants.map(
                (claimant, i) =>
                  _.has(claimant, 'transfer') && (
                    <tr key={i}>
                      <td>{claimant.firstName}</td>
                      <td>{claimant.middleName}</td>
                      <td>{claimant.lastName}</td>
                      <td className="text-center">
                        {claimant.organization || ''}
                      </td>
                      <td>{claimant.transfer.type || ''}</td>
                      <td>{claimant.transfer.typeOther || ''}</td>
                    </tr>
                  )
              )}
            </tbody>
          </Table>
        </div>
      )
    );
  }

  getMaterials() {
    const { fields } = this.props;
    const materialsExcluded = fields.materialsExcluded || {};
    const materialsIncluded = fields.materialsIncluded || {};

    let excluded = [];
    Object.keys(materialsExcluded).forEach((key) => {
      if (materialsExcluded[key] === true) {
        excluded = [...excluded, key];
      }
    });

    let included = [];
    Object.keys(materialsIncluded).forEach((key) => {
      if (materialsIncluded[key] === true) {
        included = [...included, key];
      }
    });

    return { excluded: excluded.join(', '), included: included.join(', ') };
  }

  render() {
    const { show, fields, workTypes, subWorkTypes } = this.props;

    const titleTypes = fields.titleTypes || {};
    const publishInfo = fields.publishInfo || {};
    const materialsExcluded = fields.materialsExcluded || {};
    const materialsIncluded = fields.materialsIncluded || {};
    const previousRegistration = fields.previousRegistration || {};
    const authorizedAgent = fields.authorizedAgent || {};
    const certificateRecipient = fields.certificateRecipient || {};

    return (
      <Modal
        dialogClassName="coreg-preview-modal"
        show={show}
        onHide={() => this.props.hideModal()}
        onExited={() => this.props.hideModal()}
        renderBackdrop={this.renderBackdrop}
      >
        <Modal.Header closeButton>
          <div className="modal-title">Review Your Registration</div>
        </Modal.Header>

        <Modal.Body>
          <br />
          <Row>
            <Col md={12}>
              <h4 className="text-center">
                Please review your copyright registration information before
                proceeding. To correct any information, click on "Back" to
                return to that section.
              </h4>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <p>
                <b className="text-underline">Registration Type:</b>
              </p>
              <p>
                Primary:{' '}
                <b>
                  {fields.type
                    ? getWorkTypeNameById(fields.type, workTypes)
                    : ''}
                </b>
              </p>
              <p>
                Secondary:{' '}
                <b>
                  {fields.subType
                    ? getSubWorkTypeNameById(fields.subType, subWorkTypes)
                    : ''}
                </b>
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <p>
                <b className="text-underline">Work Titles:</b>
              </p>
              <p>
                Title of Publication: <b>{titleTypes.titleOfPublication || ''}</b>
              </p>
              <p>
                State: <b>{titleTypes.state || ''}</b>
              </p>
              <p>
                Nation of Publication: <b>{titleTypes.nationOfPublication || ''}</b>
              </p>
              <p>
                ISSN: <b>{titleTypes.issn}</b>
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <p>
                <b className="text-underline">Release Information:</b>
              </p>
              <p>
                Released: <b>{fields.published === true ? 'Yes' : 'No'}</b>
              </p>
              <p>
                Year of Completion: <b>{publishInfo.completionYear || ''}</b>
              </p>
              <p>
                Date of First Publication:{' '}
                <b>
                  {fields.published === true ? publishInfo.firstDate || '' : ''}
                </b>
              </p>
              <p>
                Nation of First Publication:{' '}
                <b>
                  {fields.published === true
                    ? publishInfo.firstNation || ''
                    : ''}
                </b>
              </p>
              <p>
                ISBN:{' '}
                <b>{fields.published === true ? publishInfo.isbn || '' : ''}</b>
              </p>
              <p>
                ISRC:{' '}
                <b>{fields.published === true ? publishInfo.isrc || '' : ''}</b>
              </p>
              <p>
                ISWC:{' '}
                <b>{fields.published === true ? publishInfo.iswc || '' : ''}</b>
              </p>
              <p>
                ISMN:{' '}
                <b>{fields.published === true ? publishInfo.ismn || '' : ''}</b>
              </p>
              <p>
                ISAN:{' '}
                <b>{fields.published === true ? publishInfo.isan || '' : ''}</b>
              </p>
              <p>
                ISTC:{' '}
                <b>{fields.published === true ? publishInfo.istc || '' : ''}</b>
              </p>
              <p>
                EIDR:{' '}
                <b>{fields.published === true ? publishInfo.eidr || '' : ''}</b>
              </p>
              <p>
                ISSN:{' '}
                <b>{fields.published === true ? publishInfo.issn || '' : ''}</b>
              </p>
              <p>
                Pre-Registration Number:{' '}
                <b>
                  {fields.published === true ? publishInfo.preRegNum || '' : ''}
                </b>
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <p>
                <b className="text-underline">Authors:</b>
              </p>
              {this.renderAuthors()}
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <p>
                <b className="text-underline">Claimants:</b>
              </p>
              {this.renderClaimants()}
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <p>
                <b className="text-underline">Transfer Statements:</b>
              </p>
              {this.renderClaimantsTransfer()}
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <p>
                <b className="text-underline">Limitation of Claim:</b>
              </p>
              <p>
                Materials Excluded: <b>{this.getMaterials()['excluded']}</b>
              </p>
              <p>
                Materials Excluded (other):{' '}
                <b>{materialsExcluded['Other'] || ''}</b>
              </p>
              <p>
                New Materials included: <b>{this.getMaterials()['included']}</b>
              </p>
              <p>
                New Materials included (other):{' '}
                <b>{materialsIncluded['Other'] || ''}</b>
              </p>
              <p>
                First Previous Registration:{' '}
                <b>{previousRegistration.firstNumber || ''}</b>
              </p>
              <p>
                Year: <b>{previousRegistration.firstYear || ''}</b>
              </p>
              <p>
                Second Previous Registration:{' '}
                <b>{previousRegistration.secondNumber || ''}</b>
              </p>
              <p>
                Year: <b>{previousRegistration.secondYear || ''}</b>
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <p>
                <b className="text-underline">Rights & Permissions:</b>
              </p>
              <p>
                First Name: <b>{authorizedAgent.firstName || ''}</b>
              </p>
              <p>
                Middle Name: <b>{authorizedAgent.middleName || ''}</b>
              </p>
              <p>
                Last Name: <b>{authorizedAgent.lastName || ''}</b>
              </p>
              <p>
                Organization: <b>{authorizedAgent.organization || ''}</b>
              </p>
              <p>
                Email: <b>{authorizedAgent.email || ''}</b>
              </p>
              <p>
                Phone: <b>{authorizedAgent.tel || ''}</b>
              </p>
              <p>
                Address: <b>{authorizedAgent.address || ''}</b>
              </p>
              <p>
                City: <b>{authorizedAgent.city || ''}</b>
              </p>
              <p>
                State: <b>{authorizedAgent.state || ''}</b>
              </p>
              <p>
                Postal Code: <b>{authorizedAgent.zip || ''}</b>
              </p>
              <p>
                Country: <b>{authorizedAgent.country || ''}</b>
              </p>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <p>
                <b className="text-underline">Certificate Recipient:</b>
              </p>
              <p>
                First Name: <b>{certificateRecipient.firstName || ''}</b>
              </p>
              <p>
                Middle Name: <b>{certificateRecipient.middleName || ''}</b>
              </p>
              <p>
                Last Name: <b>{certificateRecipient.lastName || ''}</b>
              </p>
              <p>
                Email: <b>{certificateRecipient.email || ''}</b>
              </p>
              <p>
                Phone: <b>{certificateRecipient.tel || ''}</b>
              </p>
              <p>
                Organization: <b>{certificateRecipient.organization || ''}</b>
              </p>
              <p>
                Address: <b>{certificateRecipient.address || ''}</b>
              </p>
              <p>
                City: <b>{certificateRecipient.city || ''}</b>
              </p>
              <p>
                State: <b>{certificateRecipient.state || ''}</b>
              </p>
              <p>
                Postal Code: <b>{certificateRecipient.zip || ''}</b>
              </p>
              <p>
                Country: <b>{certificateRecipient.country || ''}</b>
              </p>
              <p>Content Files: {}</p>
            </Col>
          </Row>
          <Row>
            <Col md={12}>
              <b>
                You will be asked to upload your content files after you have
                submitted your payment. Please proceed to the next screen if
                there are no further changes.
              </b>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <button className="cancel" onClick={() => this.props.hideModal()}>
            Cancel
          </button>
          <button onClick={() => this.props.moveNext()}>Next</button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default PublicationCoregPreviewModal;



// WEBPACK FOOTER //
// src/components/Publication/PublicationCoregPreviewModal.jsx